import { NgModule } from '@angular/core';
import { HttpBackend } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { AppTranslationService } from './translation.service';

export function HttpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, [
    { prefix: './assets/i18n/common/', suffix: '.json' },
    { prefix: './assets/i18n/alliant-portal/', suffix: '.json' },
    { prefix: './assets/i18n/institution-portal/', suffix: '.json' },
    { prefix: './assets/i18n/student-portal/', suffix: '.json' },
    { prefix: './assets/i18n/enum/', suffix: '.json' },
  ]);
}

@NgModule({
  imports: [
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend],
      },
      fallbackLang: 'en',
    }),
  ],
  exports: [TranslateModule],
  providers: [AppTranslationService],
})
export class AppTranslationModule {}
